import { useState, useEffect, createContext, useContext } from "react";
import isToday from "date-fns/isToday";

import { Atendimento } from "../../api/api";
import { useAuth } from "../Auth/AuthContext";
import { beginAndEndOfNextWeek } from "../../components/beginAndEndOfNextWeek";

const AgendamentoContext = createContext({});
const [monday, friday] = beginAndEndOfNextWeek();

export const statusCancelamentoAgendamento = {
  pacienteNaoCompareceu: "Paciente não compareceu",
  erroCadastral: "Erro cadastral",
  naoRealizado: "Não realizado",
};

export const statusAgendamento = {
  ...statusCancelamentoAgendamento,
  emAberto: "Em aberto",
  realizado: "Realizado",
};

export const statusEmAtrasoAgendamento = "Em atraso";

export const useAgendamento = () => useContext(AgendamentoContext);

export function AgendamentoProvider({ children }) {
  const { user } = useAuth();
  const [meuHoje, setMeuHoje] = useState([]);
  const [meuSemana, setMeuSemana] = useState([]);
  const [hoje, setHoje] = useState([]);
  const [semana, setSemana] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = async () => {
    setIsLoading(true);
    const { data } = await Atendimento(user.jwt).get({
      dataAgendamento_gte: monday,
      dataAgendamento_lte: friday,
      status_contains: statusAgendamento.emAberto,
      _sort: "dataAgendamento:asc",
      _limit: -1,
    });

    // Atendimento em grupo não possuem pessoa associada, removendo-os
    const filteredData = data.filter((a) => !!a.pessoa);

    const hoje = filteredData.filter(
      (a) => isToday(new Date(a.dataAgendamento)) && !!a.pessoa,
    );

    const filterByProfissional = (a) =>
      a.profissional?.user === user.user.id ||
      a.profissionalAdicional?.some((p) => p.id === user.user.id);

    setSemana(filteredData);
    setHoje(hoje);
    setMeuHoje(hoje.filter(filterByProfissional));
    setMeuSemana(filteredData.filter(filterByProfissional));
    setIsLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const value = {
    agendamentoMeuSemana: meuSemana,
    agendamentoSemana: semana,
    agendamentoHoje: hoje,
    agendamentoMeuHoje: meuHoje,
    isLoading,
  };

  return (
    <AgendamentoContext.Provider value={value}>
      {children}
    </AgendamentoContext.Provider>
  );
}
